import { useRef } from "react";
import { motion, useInView } from "framer-motion";

// HP4 draft — "Products we love": 3 real Riversol products in a clean editorial
// row (category · name · size · price), styled to match HP2.
const PRODUCTS = [
  { category: "Cleanser", name: "Hydrating Cream Cleanser", size: "6.0 fl. oz.", price: 23, image: "https://www.riversol.com/cdn/shop/products/White_BG_-_Cream_Cleanser.png?v=1776098620&width=2500", href: "https://www.riversol.com/products/hydrating-cream-cleanser" },
  { category: "Hydration", name: "Daily Moisturizing Cream", size: "1.7 fl. oz.", price: 38, image: "https://www.riversol.com/cdn/shop/products/dmc_8215c1a3-320f-40e2-8cda-af33d45a4928.png?v=1776098827&width=1000", href: "https://www.riversol.com/products/daily-moisturizing-cream" },
  { category: "Treatment", name: "Anti-Aging Serum", size: "1.0 fl. oz.", price: 61, image: "https://www.riversol.com/cdn/shop/products/aa-serum.png?v=1776095507&width=1000", href: "https://www.riversol.com/products/anti-aging-serum" },
];

export const ProductsWeLoveV4 = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <section ref={ref} className="bg-white py-12 lg:py-16" data-testid="hp4-products-we-love">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-neutral-500 mb-8 lg:mb-10">Products we love</div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-8">
          {PRODUCTS.map((p, i) => (
            <motion.a
              key={p.name}
              href={p.href}
              data-testid={`hp4-product-${i}`}
              initial={{ opacity: 0, y: 28 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.09 }}
              className="group"
            >
              <div className="relative aspect-square overflow-hidden rounded-sm bg-riversol-sand">
                <img src={p.image} alt={p.name} className="w-full h-full object-contain p-8 lg:p-10 transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" draggable={false} />
              </div>
              <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-neutral-400">{p.category}</div>
                  <h3 className="mt-1.5 text-[17px] lg:text-[18px] tracking-[-0.01em] text-neutral-900">{p.name}</h3>
                  <div className="mt-1 text-[12px] text-neutral-500">{p.size}</div>
                </div>
                <div className="text-[15px] text-neutral-900 tabular-nums shrink-0">${p.price}</div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsWeLoveV4;
